/**
 * @module SmoothScroll
 *
 * @author christian.sany@notch-interactive.com
 */

import easings from './easings';
import getCoords from '../helpers/getcoords';

// TODO: export named function to change default settings of the scroll animations { changeDefaults }

// Scroll Factory
export const scroll = (target, options) => {

    const instance = {};
    // TODO: Give dynamicDuration some usage
    // TODO: Give cancleOnScroll some usage
    const settings = Object.assign({}, {
        duration: 1000,
        offset: 0,
        easing: 'easeInOutCubic',
        dynamicDuration: false,
        cancleOnScroll: false,
        callback: () => {}
    }, options);

    let targetPosition;

    if (typeof target !== 'number') {
        if (target instanceof HTMLElement === false) {
            throw new Error('The provided target must be a HTMLElement:', target);
        } else {
            targetPosition = getCoords(target).top;
        }
    } else {
        targetPosition = target;
    }

    // It is possible to pass the offset as a function
    if (typeof settings.offset === 'function') {
        settings.offset = settings.offset(targetPosition);

        // TODO: Add typechecking and throw an error if the offset is not an integer
    }

    // TODO: Add checking of the options

    // If the desired targetPosition is smaller than 0, just scroll to the top of the page
    // TODO: Add check, so you can't scroll 'past' the bottom
    if (targetPosition + parseInt(settings.offset) < 0) {
        targetPosition = 0;
    } else {
        targetPosition = targetPosition + parseInt(settings.offset);
    }

    let currentPosition = window.pageYOffset,
        scrollDifference = targetPosition - currentPosition,
        startTime = null,
        canceled = false,
        progress,
        nextPosition;

    const scrollAnim = (time) => {

        // Cancle animaion if the cancle method got called
        if (canceled) return;

        if (startTime === null) {
            startTime = time;
        }

        // Calculate progress (time passed since start)
        progress = time - startTime;

        // Calculate next position with easing
        nextPosition = scrollDifference * (easings[settings.easing](1 / settings.duration * progress));

        window.scrollTo(0, nextPosition + currentPosition);

        if (progress > settings.duration) {
            return settings.callback();
        }

        requestAnimationFrame(scrollAnim);
    };

    // Kick off the animation
    requestAnimationFrame(scrollAnim);

    // Public functions
    instance.cancle = () => {
        canceled = true;
    };

    return instance;
};

// Scrollinstance Factory
export default (options) => {

    const instance = {};
    const settings = Object.assign({}, {
        selector: '[data-scroll]',
        targetAttr: 'data-scroll',
        offsetAttr: 'data-scroll-offset',
        durationAttr: 'data-scroll-duration',
        easingAttr: 'data-scroll-easing',
        dynamicDurationAttr: 'data-scroll-dynamic-duration',
        cancleOnScrollAttr: 'data-scroll-cancle-on-scroll',
        duration: 1000,
        offset: 0,
        easing: 'easeInOutCubic',
        dynamicDuration: false,
        cancleOnScroll: false,
        callback: () => {}
    }, options);

    /**
     * Clickhandler
     *
     * @param {Event} e clickevent
     */
    const handler = (e) => {
        const trigger = e.target.closest(settings.selector);

        // Check if trigger is found
        if (trigger !== null) {
            e.preventDefault();

            const target = document.querySelector(trigger.getAttribute(settings.targetAttr));

            if (target instanceof HTMLElement === false) {
                console.error(trigger.getAttribute(settings.targetAttr) + ' was not found in the document!');
            } else {

                // Read options to pass to scroll function
                const options = {
                    duration: (trigger.hasAttribute(settings.durationAttr)) ? trigger.getAttribute(settings.durationAttr) : settings.duration,
                    offset: (trigger.hasAttribute(settings.offsetAttr)) ? trigger.getAttribute(settings.offsetAttr) : settings.offset,
                    easing: (trigger.hasAttribute(settings.easingAttr)) ? trigger.getAttribute(settings.easingAttr) : settings.easing,
                    dynamicDuration: (trigger.hasAttribute(settings.dynamicDurationAttr)) ? trigger.getAttribute(settings.dynamicDurationAttr) : settings.dynamicDuration,
                    cancleOnScroll: (trigger.hasAttribute(settings.cancleOnScrollAttr)) ? trigger.getAttribute(settings.cancleOnScrollAttr) : settings.cancleOnScroll
                };

                // Scroll to desired location
                scroll(target, options);
            }
        }
    };

    // Add delegate to document
    document.addEventListener('click', handler);

    /**
     * Destroys this Scrollinstance
     */
    instance.destroy = () => {

        // Remove delegate from document
        document.removeEventListener('click', handler);
    };

    return instance;
};
